import { url } from 'constants/index';

export type ControlCenterEntityType = 'player' | 'team' | 'fixture';

const PROD_ENVIRONMENT = 'PROD';

const VESSEL_ID_KEY = 'vesselid';

const ENTITY_PATHS: Record<ControlCenterEntityType, { path: string; queryKey: string }> = {
  player: { path: '/metadata/schema/players', queryKey: 'selectedPlayerId' },
  team: { path: '/metadata/schema/teams', queryKey: 'selectedTeamId' },
  fixture: { path: '/metadata/schema/games', queryKey: 'selectedGameId' },
};

export const isVesselIdKey = (key: string | undefined | null): boolean =>
  Boolean(key) && String(key).toLowerCase() === VESSEL_ID_KEY;

export const isProdEnvironment = (): boolean =>
  import.meta.env.VITE_ENVIRONMENT === PROD_ENVIRONMENT;

export const buildControlCenterLink = (
  entityType: ControlCenterEntityType | undefined,
  vesselId: string | undefined | null,
): string | null => {
  if (!entityType || !vesselId) {
    return null;
  }

  if (!isProdEnvironment()) {
    return null;
  }

  const config = ENTITY_PATHS[entityType];
  const baseUrl = (url as Record<string, string>).prod_control_center;

  if (!config || !baseUrl) {
    return null;
  }

  return `${baseUrl}${config.path}?${config.queryKey}=${encodeURIComponent(String(vesselId))}`;
};
